var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { SVGContainer } from ".";
export function Cart(_a) {
    var props = __rest(_a, []);
    return (_jsx(SVGContainer, Object.assign({}, props, { children: _jsx("path", { d: "M16.77,6.6449H12.685a.6353.6353,0,0,0,0,1.27h4.0829v2.5827H7.5416L4.8856,4.0653H16.7679Zm-6.984,8.4269a.8042.8042,0,1,1-.0023,0Zm5.9662,0a.83.83,0,1,1-.8049.83A.8176.8176,0,0,1,15.7524,15.0718ZM17.384,2.7929H4.361L3.6115.9751A.621.621,0,0,0,3.1858.6059L.77.02a.604.604,0,0,0-.6.1764A.6491.6491,0,0,0,.0276.8229a.6233.6233,0,0,0,.461.4334l2.1119.5122L8.0077,14.87a2.1455,2.1455,0,0,0,.4128,2.592,1.9894,1.9894,0,0,0,2.5442.1471,2.1376,2.1376,0,0,0,.6913-2.5282h2.2183a2.1428,2.1428,0,0,0,.5745,2.4334,1.9887,1.9887,0,0,0,2.426.1356,2.1328,2.1328,0,0,0,.8264-2.3551A2.0458,2.0458,0,0,0,15.7524,13.8l-6.84.01-.8439-2.0442H17.384A.6257.6257,0,0,0,18,11.13V3.428A.6258.6258,0,0,0,17.384,2.7929Z", fill: "currentColor" }, void 0) }), void 0));
}
//# sourceMappingURL=Cart.js.map